export default "/react/logoTeleport-512b1723.png";